import type { SearchResponse } from "src/api/SearchResponse";
import { vehicleFromSegment } from "./adapters/vehicle";

export function getCarHirePickupPlace(searchResponse: SearchResponse) {
  const destinationIndex = searchResponse.result.destinationPlace;
  const destinationPlace = searchResponse.places[destinationIndex];
  const originIndex = searchResponse.result.originPlace;
  const originPlace = searchResponse.places[originIndex];

  let canDrive = false;

  for (let route of searchResponse.routes) {
    if (route.segments.length === 1) {
      const singleSegmentVehicle = vehicleFromSegment(
        searchResponse,
        searchResponse.segments[route.segments[0]],
      );

      if (singleSegmentVehicle.kind === "car") {
        canDrive = true;
        break;
      }
    }
  }

  const carPickupPlace = canDrive ? originPlace : destinationPlace;
  return { carPickupPlace, originPlace, destinationPlace };
}
